import { Box, styled } from '@mui/material';
import { shouldForwardPropExclude } from '@synergy/utils';

export const CollapseButtonBox = styled(Box, { shouldForwardProp: shouldForwardPropExclude('collapsed', 'width') })<{
    collapsed: boolean;
    width: number;
}>(({ theme, collapsed, width }) => ({
    position: 'fixed',
    bottom: 0,
    right: 0,
    height: '86px',
    width: width - 1,
    transition: 'width 0.3s ease-out',
    boxSizing: 'border-box',
    borderTop: '1px solid #dcdcdc',
    // Opaque footer backdrop so scrolling content does not show through behind
    // the fixed collapse button (otherwise the button appears to float).
    backgroundColor: theme.general.colors.activitySidebarBackground,

    ...(collapsed && {
        display: 'none',
    }),
}));
